import { createClient } from "@supabase/supabase-js";
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "@/lib/env";

// SUPABASE_URL / SUPABASE_ANON_KEY are ALWAYS defined (env var, or public default
// baked into the bundle in lib/env.js). This guarantees createClient never throws
// "supabaseUrl is required" and the app never black-screens at import time.
let _client;
try {
  _client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storageKey: "persona-dm-auth",
    },
  });
} catch (err) {
  // Safety net: if createClient somehow throws, expose a stub so pages still render.
  console.warn("[supabase] createClient failed, using stub:", err?.message || err);
  const noSession = { data: { session: null }, error: null };
  const noUser = { data: { user: null }, error: null };
  _client = {
    auth: {
      getSession: async () => noSession,
      getUser: async () => noUser,
      onAuthStateChange: (_cb) => ({ data: { subscription: { unsubscribe() {} } } }),
      signInWithPassword: async () => ({ data: null, error: new Error("Auth unavailable") }),
      signUp: async () => ({ data: null, error: new Error("Auth unavailable") }),
      signOut: async () => ({ error: null }),
    },
  };
}

export const supabase = _client;
